export const PILLS_LIMITS = { MIN: 5, REQUEST_LIMIT: 50 };
